import { ACCESS_CARD, UPDATE_ACCESS_CARD } from "./constant";

export function getAccessCardsRequest(data){
  return {
    type:ACCESS_CARD.PENDING,
    data
  }
}

export function getAccessCardsSuccess(data){
  return {
    type:ACCESS_CARD.SUCCESS,
    data
  }
}

export function getAccessCardsError(err){
  return {
    type:ACCESS_CARD.ERROR,
    err
  }
}

export function updateAccessCardRequest(data){
  return {
    type:UPDATE_ACCESS_CARD.PENDING,
    data
  }
}

export function updateAccessCardSuccess(data){
  return {
    type:UPDATE_ACCESS_CARD.SUCCESS,
    data
  }
}

export function updateAccessCardError(err){
  return {
    type:UPDATE_ACCESS_CARD.ERROR,
    err
  }
}
